import { NavigationLogic } from './Logic/NavigationLogic'
import { Middleware } from './Middleware'

const middleware = Middleware.middleware([NavigationLogic])

export const middlewareReducer = Middleware.reducer({
  success(state) {
    const newNavigation = { ...state.navigation }
    const [mod, view] = newNavigation.path.split('/').slice(1)
    newNavigation.app = { mod, view }

    return { ...state, navigation: newNavigation }
  },
})

export function attach(store) {
  Middleware.attach(store)
}

export default middleware
